import React from 'react';
import { useIntl } from 'react-intl';
import ErrorPage from 'components/ErrorPages/ErrorPage';

function BlockedUserErrorPage() {
  const intl = useIntl();

  return (
    <ErrorPage
      headerContent={
        <>
          {intl.formatMessage({
            id: 'auth0.errorPages.blockedUser.headerLine1',
          })}
          <br />
          {intl.formatMessage({
            id: 'auth0.errorPages.blockedUser.headerLine2',
          })}
        </>
      }
      subheaderContent={
        <>
          <a
            className="error-page__contact-support"
            href="https://cloud.incorta.com/support"
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({
              id: 'auth0.errorPages.blockedUser.contactSupport',
            })}
          </a>
          {intl.formatMessage({
            id: 'auth0.errorPages.blockedUser.subheader',
          })}
        </>
      }
    ></ErrorPage>
  );
}

export default BlockedUserErrorPage;
